<script lang="ts">
  import { themePreference, resolvedTheme } from "../stores/theme";

  function toggle(): void {
    themePreference.set($resolvedTheme === "dark" ? "light" : "dark");
  }
</script>

<button class="toggle" onclick={toggle} aria-label="Toggle dark mode" type="button">
  {#if $resolvedTheme === "dark"}
    ☀️
  {:else}
    🌙
  {/if}
</button>

<style>
  .toggle {
    background: none;
    border: none;
    font-size: 1.3rem;
    line-height: 1;
    padding: 0.5rem;
    cursor: pointer;
    border-radius: var(--radius);
  }
  .toggle:active {
    background: var(--surface-alt);
  }
</style>
